"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array-buffer.slice");

require("core-js/modules/es.data-view");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.bind");

require("core-js/modules/es.function.name");

require("core-js/modules/es.map");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.split");

require("core-js/modules/es.typed-array.uint8-array");

require("core-js/modules/es.typed-array.copy-within");

require("core-js/modules/es.typed-array.every");

require("core-js/modules/es.typed-array.fill");

require("core-js/modules/es.typed-array.filter");

require("core-js/modules/es.typed-array.find");

require("core-js/modules/es.typed-array.find-index");

require("core-js/modules/es.typed-array.for-each");

require("core-js/modules/es.typed-array.includes");

require("core-js/modules/es.typed-array.index-of");

require("core-js/modules/es.typed-array.iterator");

require("core-js/modules/es.typed-array.join");

require("core-js/modules/es.typed-array.last-index-of");

require("core-js/modules/es.typed-array.map");

require("core-js/modules/es.typed-array.reduce");

require("core-js/modules/es.typed-array.reduce-right");

require("core-js/modules/es.typed-array.reverse");

require("core-js/modules/es.typed-array.set");

require("core-js/modules/es.typed-array.slice");

require("core-js/modules/es.typed-array.some");

require("core-js/modules/es.typed-array.sort");

require("core-js/modules/es.typed-array.subarray");

require("core-js/modules/es.typed-array.to-locale-string");

require("core-js/modules/es.typed-array.to-string");

require("core-js/modules/web.dom-collections.iterator");

require("core-js/modules/web.timers");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeSizeAndOrientation = normalizeSizeAndOrientation;
exports.rotateImage = rotateImage;
Object.defineProperty(exports, "readBlobAsDataUrl", {
  enumerable: true,
  get: function get() {
    return _readImage.readBlobAsDataUrl;
  }
});
Object.defineProperty(exports, "readBlobAsArrayBuffer", {
  enumerable: true,
  get: function get() {
    return _readImage.readBlobAsArrayBuffer;
  }
});
Object.defineProperty(exports, "loadImage", {
  enumerable: true,
  get: function get() {
    return _readImage.loadImage;
  }
});
Object.defineProperty(exports, "canvasToBlob", {
  enumerable: true,
  get: function get() {
    return _readImage.canvasToBlob;
  }
});

require("regenerator-runtime/runtime");

var _readImage = require("./readImage");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NotAJpeg = /*#__PURE__*/function (_Error) {
  _inherits(NotAJpeg, _Error);

  var _super = _createSuper(NotAJpeg);

  function NotAJpeg() {
    _classCallCheck(this, NotAJpeg);

    return _super.call(this, 'Not a JPEG');
  }

  return NotAJpeg;
}( /*#__PURE__*/_wrapNativeSuper(Error)); // Extracts the orientation EXIF tag from a JPEG, adapted from http://stackoverflow.com/a/32490603


function getOrientation(_x) {
  return _getOrientation.apply(this, arguments);
}

function _getOrientation() {
  _getOrientation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(blob) {
    var data, view, length, offset, marker, isLittleEndian, tags, i;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _readImage.readBlobAsArrayBuffer)(blob);

          case 2:
            data = _context.sent;
            view = new DataView(data);

            if (!(view.getUint16(0, false) !== 0xFFD8)) {
              _context.next = 6;
              break;
            }

            throw new NotAJpeg();

          case 6:
            length = view.byteLength;
            offset = 2;

          case 8:
            if (!(offset < length)) {
              _context.next = 34;
              break;
            }

            marker = view.getUint16(offset, false);
            offset += 2;

            if (!(marker === 0xFFE1)) {
              _context.next = 27;
              break;
            }

            if (!(view.getUint32(offset += 2, false) !== 0x45786966)) {
              _context.next = 14;
              break;
            }

            throw new Error('JPEG format error');

          case 14:
            isLittleEndian = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, isLittleEndian);
            tags = view.getUint16(offset, isLittleEndian);
            offset += 2;
            i = 0;

          case 19:
            if (!(i < tags)) {
              _context.next = 25;
              break;
            }

            if (!(view.getUint16(offset + i * 12, isLittleEndian) === 0x0112)) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", view.getUint16(offset + i * 12 + 8, isLittleEndian));

          case 22:
            i++;
            _context.next = 19;
            break;

          case 25:
            _context.next = 32;
            break;

          case 27:
            if (!((marker & 0xFF00) !== 0xFF00)) {
              _context.next = 31;
              break;
            }

            return _context.abrupt("break", 34);

          case 31:
            offset += view.getUint16(offset, false);

          case 32:
            _context.next = 8;
            break;

          case 34:
            return _context.abrupt("return", 1);

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getOrientation.apply(this, arguments);
}

function calculateScale(width, height, maxSize) {
  if (width <= maxSize && height <= maxSize) {
    return [width, height, 1];
  }

  var aspectRatio = width / height;
  var scale;

  if (aspectRatio >= 1) {
    scale = maxSize / width;
  } else {
    scale = maxSize / height;
  }

  width = (width * scale).toFixed(0);
  height = (height * scale).toFixed(0);
  return [width, height, scale];
}

function normalizeSizeAndOrientation(_x2, _x3) {
  return _normalizeSizeAndOrientation.apply(this, arguments);
}

function _normalizeSizeAndOrientation() {
  _normalizeSizeAndOrientation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(blob, maxSize) {
    var orientation, img, _calculateScale, _calculateScale2, width, height, scale, canvas, _ref, ctx;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return getOrientation(blob);

          case 3:
            orientation = _context2.sent;
            _context2.next = 13;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);

            if (!(_context2.t0 instanceof NotAJpeg)) {
              _context2.next = 12;
              break;
            }

            orientation = 1;
            _context2.next = 13;
            break;

          case 12:
            throw _context2.t0;

          case 13:
            _context2.t1 = _readImage.loadImage;
            _context2.next = 16;
            return (0, _readImage.readBlobAsDataUrl)(blob);

          case 16:
            _context2.t2 = _context2.sent;
            _context2.next = 19;
            return (0, _context2.t1)(_context2.t2);

          case 19:
            img = _context2.sent;
            _calculateScale = calculateScale(img.width, img.height, maxSize), _calculateScale2 = _slicedToArray(_calculateScale, 3), width = _calculateScale2[0], height = _calculateScale2[1], scale = _calculateScale2[2];
            canvas = document.createElement('canvas');

            if (orientation > 4 && orientation < 9) {
              // Image is rotated, so width/height of resulting image will be swapped
              _ref = [height, width];
              width = _ref[0];
              height = _ref[1];
            }

            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            _context2.t3 = orientation;
            _context2.next = _context2.t3 === 2 ? 29 : _context2.t3 === 3 ? 31 : _context2.t3 === 4 ? 33 : _context2.t3 === 5 ? 35 : _context2.t3 === 6 ? 37 : _context2.t3 === 7 ? 39 : _context2.t3 === 8 ? 41 : 43;
            break;

          case 29:
            ctx.transform(-scale, 0, 0, scale, width, 0);
            return _context2.abrupt("break", 45);

          case 31:
            ctx.transform(-scale, 0, 0, -scale, width, height);
            return _context2.abrupt("break", 45);

          case 33:
            ctx.transform(scale, 0, 0, -scale, 0, height);
            return _context2.abrupt("break", 45);

          case 35:
            ctx.transform(0, scale, scale, 0, 0, 0);
            return _context2.abrupt("break", 45);

          case 37:
            ctx.transform(0, scale, -scale, 0, width, 0);
            return _context2.abrupt("break", 45);

          case 39:
            ctx.transform(0, -scale, -scale, 0, width, height);
            return _context2.abrupt("break", 45);

          case 41:
            ctx.transform(0, -scale, scale, 0, 0, height);
            return _context2.abrupt("break", 45);

          case 43:
            ctx.transform(scale, 0, 0, scale, 0, 0);
            return _context2.abrupt("break", 45);

          case 45:
            ctx.drawImage(img, 0, 0);
            return _context2.abrupt("return", (0, _readImage.canvasToBlob)(canvas, 'image/jpeg', 0.95));

          case 47:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _normalizeSizeAndOrientation.apply(this, arguments);
}

function rotateImage(_x4, _x5, _x6) {
  return _rotateImage.apply(this, arguments);
} // toBlob polyfill for Edge, from https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob#Polyfill


function _rotateImage() {
  _rotateImage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, maxSize, direction) {
    var img, _calculateScale3, _calculateScale4, width, height, scale, canvas, _ref2, ctx;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _readImage.loadImage)(url);

          case 2:
            img = _context3.sent;
            _calculateScale3 = calculateScale(img.width, img.height, maxSize), _calculateScale4 = _slicedToArray(_calculateScale3, 3), width = _calculateScale4[0], height = _calculateScale4[1], scale = _calculateScale4[2];
            canvas = document.createElement('canvas');
            _ref2 = [height, width];
            width = _ref2[0];
            height = _ref2[1];
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');

            if (direction === 'clockwise') {
              ctx.transform(0, scale, -scale, 0, width, 0);
            } else {
              ctx.transform(0, -scale, scale, 0, 0, height);
            }

            ctx.drawImage(img, 0, 0);
            return _context3.abrupt("return", (0, _readImage.canvasToBlob)(canvas, 'image/jpeg', 1));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _rotateImage.apply(this, arguments);
}

if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value: function value(callback, type, quality) {
      var dataURL = this.toDataURL(type, quality).split(',')[1];
      setTimeout(function () {
        var binStr = atob(dataURL);
        var len = binStr.length;
        var arr = new Uint8Array(len);

        for (var i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }

        callback(new Blob([arr], {
          type: type || 'image/png'
        }));
      });
    }
  });
}